export const UseMessage = () => {

    const Message = {};

    // 共通
    Message.Common = {};
    Message.Common.SAVE = "保存しました。";
    Message.Common.REGIST = "登録しました。";
    Message.Common.ADD = "追加しました。";
    Message.Common.UPDATE = "変更しました。";
    Message.Common.RENEWAL = "更新しました。";
    Message.Common.DELETE = "削除しました。";

    Message.Common.MAIL_CONFIRM = "メールをご確認ください。";
    Message.Common.MAIL_ERROR_SEND = "メール送信に失敗しました。";
    Message.Common.MAIL_ERROR_UPLOAD = "メール配信時にエラーが発生しました。";
    Message.Common.FILE_DOWNLOAD_MAIL_CONFIRM = "ファイルダウンロードのメールを送信しました。メールをご確認ください。";

    Message.Common.IMPORT_CONPLATE = "インポート処理が正常終了しました。";
    Message.Common.IMPORT_ERROR = "インポート処理でエラーが発生しました。";

    Message.Common.NON_SELECT = "選択してください。";
    Message.Common.CONFIRM_INPUT = "入力内容を確認してください。";
    Message.Common.CONFIRM_SAVE = "保存します。よろしいですか？";
    Message.Common.CONFIRM_REGIST = "登録します。よろしいですか？";
    Message.Common.CONFIRM_MODAL_CLOSE = "保存していない更新内容は破棄されます。ダイアログを閉じてよろしいですか？";

    Message.Common.ERROR = "error";
    Message.Common.ERROR_JPN = "エラー";

    // ログイン
    Message.Login = {};
    Message.Login.NOT_AUTHORITY_ADMIN = "権限情報が取得出来ませんでした。管理者へ連絡して下さい。";
    Message.Login.NOT_AUTHORITY_SYSTEM_ADMIN = "権限情報が取得出来ませんでした。システム管理者へ連絡して下さい。";
    Message.Login.UPDATE_PASSWORD = "パスワードを変更しました。";
    Message.Login.CONFIRM_OLD_PASSWARD = "旧パスワードを確認してください。";

    // 利用企業
    Message.Riyocorp = {};
    Message.Riyocorp.NON_UNIQUE = "既に使用されている利用企業コードです。";
    Message.Riyocorp.NOT_POST = "郵便番号が存在しません。";

    // ユーザ
    Message.Riyocorpuser = {};
    Message.Riyocorpuser.NOTICE = "選択データの通知を行いました。";
    Message.Riyocorpuser.INVALID = "選択データの無効化を行いました。";
    Message.Riyocorpuser.SAVE = "保存しました。（※権限情報等を反映するには、再度ログインをしてください。）";
    Message.Riyocorpuser.NON_UNIQUE = "既に使用されているユーザコードです。";
    Message.Riyocorpuser.NON_JIGYOSHO = "事業所が個別指定の場合、事業所を選択してください。";
    Message.Riyocorpuser.NON_RIYOCORP = "個別指定の場合、利用企業を選択してください。";
    Message.Riyocorpuser.NON_SELECT = "対象データを選択してください。";
    Message.Riyocorpuser.WARNING_ISSUE_NON_MIHAKKOU = "未発行でないユーザが選択されています。<br>未発行でない場合は、パスワードを初期化します。";

    // 事業所
    Message.Jigyosho = {};
    Message.Jigyosho.NON_UNIQUE = "入力された事業所コードはすでに使われています。";
    Message.Jigyosho.NG_DELETE_HIST_DATA_FOR_ONE = "履歴を0件にすることはできません。";
    Message.Jigyosho.NG_ADD_HIST_DATA_FOR_STARTDAY = "同じ開始日の履歴は登録できません。";

    // 職場
    Message.Shokuba = {};
    Message.Shokuba.NON_UNIQUE = "入力された職場コードはすでに使われています。";
    Message.Shokuba.NG_DELETE_HIST_DATA_FOR_ONE = "履歴が１件の場合、削除できません。";
    Message.Shokuba.NG_ADD_HIST_DATA_FOR_STARTDAY = "同じ開始日の履歴は登録できません。";

    // 受検者
    Message.Jukensha = {};
    Message.Jukensha.UPLOAD = "発行処理を行いました。";
    Message.Jukensha.ERR_SEND_MAIL = "メール送信に失敗しました。";
    Message.Jukensha.ERR_UPDATE_DATA = "データ更新に失敗しました。";
    Message.Jukensha.NOT_TARGET = "対象が見つかりませんでした。";
    Message.Jukensha.ERR_DELETE = "削除に失敗しました。";
    Message.Jukensha.NOT_USER = "対象受検者が見つかりません。";
    Message.Jukensha.JUKEN_FINISH_USER = "既に受検済みです。削除できません。";
    Message.Jukensha.LOGIN_USE_USER = "既に使用されているログインIDです。別のログインIDを入力して下さい。";
    Message.Jukensha.NOT_CORP = "利用企業が見つかりません。";
    Message.Jukensha.NOT_SHOKUBA_HIST = "対象職場履歴が見つかりません。";
    Message.Jukensha.ERR_UPDATE = "データ更新時にエラーが発生しました。";
    Message.Jukensha.ERR_REGIST = "データ登録時にエラーが発生しました。";
    Message.Jukensha.PLEASE_SET_INFO_DATA = "職場情報を設定してください。";
    Message.Jukensha.MAIL_DELETE_POSTMAIL_CANCEL = "メールアドレスを削除すると配信予定だったメールはキャンセルされます。よろしいですか？";
    Message.Jukensha.NOT_SELECT = "受検者が選択されていません。";
    Message.Jukensha.CONFIRM_JUKENSHA_MUKO = "取込んだ受検者以外を無効にします。よろしいでしょうか？";

    // 受検実施
    Message.Jisshi = {};
    Message.Jisshi.UPDATE_COMPLATE = "{0}の変更を行いました。";
    Message.Jisshi.FINISH = "受検実施完了処理を行いました。";
    Message.Jisshi.NON_UNIQUE_JIGYOSHO = "入力された事業所コードはすでに使われています。";
    Message.Jisshi.NON_SELECT_JUDGE = "評価方法を入力して下さい。";
    Message.Jisshi.NON_MAILADDRESS = "受検方法がWEBの場合、対象者はメールアドレスが登録されていなければなりません。";
    Message.Jisshi.NON_UPDATE_SEND_SUMI = "通知済みのものは公開日、通知日を変更できません。選択を解除しました。";
    Message.Jisshi.OUTPUT_YUSOKIT = "郵送キットを出力します。よろしいですか？";
    Message.Jisshi.OUTPUT_YUSOKIT_COMPLATE = "郵送キットを出力しました。";
    Message.Jisshi.OUTPUT_YUSOKIT_ERROR = "郵送キット出力に失敗しました。";
    Message.Jisshi.NON_SELECTED_YUSOKIT_JUKENINFO = "郵送キットを出力する受検情報を選択してください。";
    Message.Jisshi.OUTPUT_RESERCHSHEET_ERROR = "調査票出力に失敗しました。";
    Message.Jisshi.NON_SELECTED_RESERCHSHEET_JUKENINFO = "調査票を出力する受検情報を選択してください。";
    Message.Jisshi.RESERCHSHEET_DATA_FOR_ONE = "受検情報を１件のみ選択してください。";
    Message.Jisshi.NON_SELECTED_STARTDAY_JUKENINFO = "開始日を変更する受検情報を選択してください。";
    Message.Jisshi.NON_SELECTED_ENDDAY_JUKENINFO = "終了日を変更する受検情報を選択してください。";
    Message.Jisshi.UPDATE_STARTDAY_COMPLATE = "受検開始日の変更を行いました。";
    Message.Jisshi.UPDATE_ENDDAY_COMPLATE = "受検終了日の変更を行いました。";
    Message.Jisshi.UPDATE_DAY_ERROR = "日付更新に失敗しました。";
    Message.Jisshi.INVALID_DATE_ERROR = "受検開始日と受検終了日の大小関係が不正です。";
    Message.Jisshi.NON_SELECTED_UPDATE_JUKENINFO = "完了する受検情報を選択してください。";
    Message.Jisshi.UPDATE_STATUS_ERROR = "ステータス更新に失敗しました。";
    Message.Jisshi.JOKYO_SHEET_OUTPUT = "調査票出力";
    Message.Jisshi.JOKYO_SHEET_OUTPUT_BODY = "チェックした受検者の調査票を出力します。<br />よろしいですか。";
    Message.Jisshi.JOKYO_SHEET_OUTPUT_RESULTTITLE = "選択データの調査票出力を行いました";
    Message.Jisshi.NON_SELECTED_JUKENKANSHO = "受検勧奨対象を選択してください。";
    Message.Jisshi.SELECT_JUKEN_FINISH_OUT = "受検が完了している受検者を選択することはできません。該当の選択を解除しました。";
    Message.Jisshi.SELECT_JUKEN_FINISH = "受検が完了している受検者を選択することはできません。";

    // 受検実施状況
    Message.JisshiProcess = {};
    Message.JisshiProcess.UPDATE_STATUS = "ステータスを更新しました。";

    // 未受検
    Message.Mijuken = {};
    Message.Mijuken.RETRY = "選択データの再通知を行いました。";
    Message.Mijuken.NOT_INFO = "更新対象の受検情報が見つかりませんでした。";
    Message.Mijuken.ERR_UPDATE = "受検情報の更新でエラーが発生しました。";
    Message.Mijuken.DELETE = "選択データを削除しました。";
    Message.Mijuken.NON_SELECTED_SAITSUTI = "再通知対象を選択してください。";
    Message.Mijuken.NON_SELECTED_SHEETOUTPUT = "調査票出力対象を選択してください。";
    Message.Mijuken.NON_SELECTED_JUKENKANSHO = "受検勧奨対象を選択してください。";
    Message.Mijuken.ERR_SEND_MAIL = "メール送信に失敗しました。";
    Message.Mijuken.ERR_UPDATE_DATA = "データ更新に失敗しました。";
    Message.Mijuken.NOT_TARGET = "対象が見つかりませんでした。";
    Message.Mijuken.NOT_USER = "対象者が見つかりません。";
    Message.Mijuken.NOT_JUKENHOHO_WEB = "受検方法がWEB以外の受検情報が含まれています。";
    Message.Mijuken.JUKENSTATUS_JUKENSUMI = "すでに受検済みの情報が含まれています。";
    Message.Mijuken.ALL_JUKENSTATUS_JUKENSUMI = "選択されている受検情報が全て受検済みの方なので、\n送信対象データが存在しませんでした。";
    Message.Mijuken.OUTPUT_SHEET_TITLE = "調査票出力";
    Message.Mijuken.OUTPUT_SHEET_BODY = "チェックした調査票を出力します。<br />よろしいですか。";
    Message.Mijuken.SELECTDATA_OUTPUT = "選択データの調査票出力を行いました。";
    Message.Mijuken.JUKEN_KANSHO_TITLE = "受検勧奨";
    Message.Mijuken.JUKEN_KANSHO_BODY = "選択されている受検情報に対し、受検を勧奨します。<br />すでに受検済みの方には、送信されません。よろしいですか。";
    Message.Mijuken.SELECTDATA_JUKEN_KANSHO = "受検を勧奨";
    Message.Mijuken.ENCOURAGE = "選択データの受検勧奨処理を行いました";
    Message.Mijuken.SAITUCHI_TITLE = "再通知";
    Message.Mijuken.SAITUCHI_BODY = "選択されている受検者に、再通知を行います。<br />よろしいですか。";
    Message.Mijuken.SELECTDATA_SAITUCHI = "選択データの再通知を行いました";

    // 受検状況
    Message.Jyokyo = {};
    Message.Jyokyo.RETRY = "選択データの再通知を行いました。";
    Message.Jyokyo.NOT_INFO = "更新対象の受検情報が見つかりませんでした。";
    Message.Jyokyo.ERR_UPDATE = "受検情報の更新でエラーが発生しました。";
    Message.Jyokyo.UPLOAD_JUKEN = "選択データの未受検者公開処理を行いました。";
    Message.Jyokyo.UPDATE_PROCCESS = "受検方法を変更しました。";
    Message.Jyokyo.DELETE = "選択データを削除しました。";
    Message.Jyokyo.ENCOURAGE = "選択データの受検勧奨処理を行いました。";
    Message.Jyokyo.NON_SELECTED_JOKYO_SAITUCHI = "再通知対象を選択してください。";
    Message.Jyokyo.NON_JOKYO_SAITUCHI_JUKENHOHO_WEB = "受検方法がWEB以外の受検情報が含まれています。";
    Message.Jyokyo.JOKYO_SAITUCHI = "再通知";
    Message.Jyokyo.JOKYO_SAITUCHI_BODY = "選択されている受検者に、再通知を行います。<br />よろしいですか。";
    Message.Jyokyo.JOKYO_SAITUCHI_RESULTTITLE = "選択データの再通知を行いました";
    Message.Jyokyo.NON_SELECTED_JOKYO_MIJUKENSHAKOKAI = "未受検者公開対象を選択してください。";
    Message.Jyokyo.SELECTED_ALL_MIJUKENSHA_KOKAI = "選択された全てのデータが、既に未受検者として事業者へ公開されています。";
    Message.Jyokyo.SELECTED_JUKENSUMI = "受検済みの情報が含まれています。";
    Message.Jyokyo.JOKYO_MIJUKENSHAKOKAI = "未受検者公開";
    Message.Jyokyo.JOKYO_MIJUKENSHAKOKAI_BODY = "選択されている受検者を未受検者として事業者に公開します。<br />よろしいですか。";
    Message.Jyokyo.JOKYO_MIJUKENSHAKOKAI_BUTTON = "公開";
    Message.Jyokyo.JOKYO_MIJUKENSHAKOKAI_RESULTTITLE = "選択データの公開を行いました";
    Message.Jyokyo.NON_SELECTED_JOKYO = "対象データを一覧から選択してください。";
    Message.Jyokyo.NON_DELETE_JUKEN_INFO = "受検情報が削除できない受検情報が含まれています。";
    Message.Jyokyo.NON_SELECTED_TARGET_OUTPUT = "調査票出力対象を選択してください。";
    Message.Jyokyo.JOKYO_SHEET_OUTPUT = "調査票出力";
    Message.Jyokyo.JOKYO_SHEET_OUTPUT_BODY = "チェックした受検者の調査票を出力します。<br />よろしいですか。";
    Message.Jyokyo.JOKYO_SHEET_OUTPUT_RESULTTITLE = "選択データの調査票出力を行いました";
    Message.Jyokyo.NON_SELECTED_JUKENKANSHO = "受検勧奨対象を選択してください。";
    Message.Jyokyo.JOKYO_JUKENKANSHO = "受検勧奨";
    Message.Jyokyo.JOKYO_JUKENKANSHO_BODY = "選択されている受検情報に対し、受検を勧奨します。<br />すでに受検済みの方には、送信されません。よろしいですか。";
    Message.Jyokyo.JOKYO_JUKENKANSHO_BUTTON = "受検を勧奨";
    Message.Jyokyo.JOKYO_JUKENKANSHO_RESULTTITLE = "選択データの受検勧奨処理を行いました";
    Message.Jyokyo.JOKYO_JUKENKANSHO_NOT_TARGET = "選択されている受検情報が全て受検済みの方なので、送信対象データが存在しませんでした。";

    // 受検登録
    Message.Check = {};
    Message.Check.CONFIRM_CLEAR = "編集状態を元に戻します。よろしいですか。";
    Message.Check.NOT_JUKENDATE_BETWEEN = "受検日を受検開始日({0})～受検終了日({1})の範囲で入力してください。";
    Message.Check.NOT_ANSWER = "No.{0}の回答を選択してください。";
    Message.Check.CONFIRM_SAVE_NON_ANSWER = "未回答(9)を含む状態で保存します。よろしいですか。";
    Message.Check.CONFIRM_SAVE = "入力データを保存します。よろしいですか。";

    // 受検結果
    Message.Result = {};
    Message.Result.AGREE_INFO = "情報提供の同意許可の設定を行いました。";
    Message.Result.UPDATE = "面接対象ステータスを更新しました。\n\n※面接対象ステータスは最終確定されていません。\n　最終確定は全ての面接対象者を設定した後、「受検実施状況」画面から行ってください。";
    Message.Result.NON_SELECT_JUDGE = "評価方法を入力して下さい。";
    Message.Result.SAIHANTEI_ERROR = "再判定に失敗しました。";
    Message.Result.JUKENSTATUS_UPDATE_ERROR = "受検結果面接対象設定に失敗しました。";
    Message.Result.NON_SELECTED_RESULT_INFO = "出力対象を選択してください。";
    Message.Result.OUTPUT_RESULT = "結果出力";
    Message.Result.SEND_MAIL_OUTPUT_RESULT_BODY = "選択されている受検情報に対して、<br />対象者に結果出力メールを送信します。<br />よろしいですか。";
    Message.Result.SEND_MAIL_OUTPUT_RESULT_RESULTTITLE = "結果出力処理を行いました。";
    Message.Result.SEND_MAIL_OUTPUT_RESULT_RESULTBODY = "※面接対象ステータスは最終確定されていません。<br />最終確定は全ての面接対象者を設定した後、<br />「受検実施状況」画面から行ってください。";
    Message.Result.NON_SELECTED_JUKEN_RESULT_INFO = "受検結果を出力する受検情報を選択してください。";
    Message.Result.JUKEN_OUTPUT_RESULT = "受検結果出力";
    Message.Result.SEND_MAIL_JUKEN_OUTPUT_RESULT_BODY = "選択されている受検情報に対して、<br />対象者に受検結果出力メールを送信します。<br />よろしいですか。";
    Message.Result.SEND_MAIL_JUKEN_OUTPUT_RESULT_RESULTTITLE = "受検結果出力処理を行いました。";
    Message.Result.SEND_MAIL_JUKEN_OUTPUT_RESULT_RESULTBODY = "※面接対象ステータスは最終確定されていません。<br />最終確定は全ての面接対象者を設定した後、<br />「受検実施状況」画面から行ってください。";
    Message.Result.NON_SELECTED_YUSOKIT_JUKENINFO = "郵送キットを出力する受検情報を選択してください。";
    Message.Result.YUSOKIT_INSASTU = "郵送キット印刷";
    Message.Result.SEND_MAIL_YUSOKIT_INSASTU_BODY = "選択されている受検情報に対して、<br />対象者に郵送キットメールを送信します。<br />よろしいですか。";
    Message.Result.SEND_MAIL_YUSOKIT_INSASTU_RESULTTITLE = "郵送キット印刷処理を行いました。";
    Message.Result.SEND_MAIL_YUSOKIT_INSASTU_RESULTBODY = "※面接対象ステータスは最終確定されていません。<br />最終確定は全ての面接対象者を設定した後、<br />「受検実施状況」画面から行ってください。";

    // 面接指導
    Message.Interview = {};
    Message.Interview.ENCOURAGE = "勧奨処理を行いました。";
    Message.Interview.ERR_SEND_MAIL = "メール送信に失敗しました。";
    Message.Interview.ERR_UPDATE_DATA = "データ更新に失敗しました。";
    Message.Interview.NOT_TARGET = "対象が見つかりませんでした。";
    Message.Interview.NOT_USER = "対象者が見つかりません。";
    Message.Interview.NOT_INTERVIEW = "対象面接指導が見つかりません。";
    Message.Interview.FILE_DELETE = "ファイルを削除します。よろしいですか？";
    Message.Interview.NON_SELECTED_JUKENSHA = "受検者が選択されていません。";
    Message.Interview.NOT_JUKENHOHO_WEB = "選択されている面接情報の受検方法が、全て紙面の受検情報です。";
    Message.Interview.DOWNLOAD_JUKENKEKKA = "受検結果をダウンロードします。よろしいですか。";

    // 分析
    Message.Analysis = {};
    Message.Analysis.NON_SELECT = "ストレス判定を指定してください。";
    Message.Analysis.NON_TARGET_SELECT = "ストレス判定対象を選択してください。";
    Message.Analysis.ONE_TARGET_SELECT = "「一つの職場」を選択した時は、一覧より１件のみ選択してください。";
    Message.Analysis.SELECT_UNDER_10 = "10人未満の職場が選択されているため、表示できません。（{0}人）";
    Message.Analysis.SELECT_UNDER_10_TOTAL = "職場の合計人数が10人未満のため、表示できません。（{0}人）";
    Message.Analysis.NOT_SAME_CHOSAHYO = "調査票がすべて同じになるように選択してください。";

    // 報告書
    Message.Report = {};

    // 郵送
    Message.YusoSohu = {};
    Message.YusoSohu.NOT_SEND_DATA = "発送待ちのデータが存在しません。";
    Message.YusoSohu.SEND = "発送済みにしました。";

    // メールテンプレート
    Message.MailTemplate = {};
    Message.MailTemplate.SEND_END = "テストメールを送信しました。";

    // 郵送テンプレート
    Message.YusoTemplate = {};
    Message.YusoTemplate.SEND_END = "テストメールを送信しました。";

    // 受検ユーザ
    Message.JukenUser = {};
    Message.JukenUser.NOT_SELECT_INFO = "面接情報が取得できませんでした。";
    Message.JukenUser.NOT_UPDATE_INFO = "面接情報が更新できませんでした。";
    Message.JukenUser.NOT_SELECT_RESULT = "受検結果情報が取得できませんでした。";
    Message.JukenUser.NOT_UPDATE_RESULT = "受検結果情報が更新できませんでした。";
    Message.JukenUser.NOT_PROGRESS_DATA = "実施中のストレスチェックが存在しません。";
    Message.JukenUser.NON_SELECT_JUKEN = "受検情報を選択してください。";
    Message.JukenUser.CONFIRM_NON_AGREE_CHECK = "「公開に同意」のチェックボックスがされていません。よろしいですか。";
    Message.JukenUser.CONFIRM_CANCEL_INTERVIEW = "面接の申し入れを辞退します。本当によろしいですか。";
    Message.JukenUser.WARNING_NON_AGREE_CHECK = "「公開に同意」のチェックボックスがされていません。";
    Message.JukenUser.CONFIRM_RETURN_TO_PREVIOUS_QUESTION = "この設問の回答内容は破棄されます。よろしいですか？";
    Message.JukenUser.CONFIRM_RETURN_TO_FIRST_SCREEN = "全ての回答内容は破棄されます。よろしいですか？";

    // セルフケアプログラム
    Message.UserSelfcare = {};
    Message.UserSelfcare.NO_ATTENDANCE_DATA = "受講データがありません";

    // メール関連
    Message.MailGroup = {};
    Message.MailGroup.BUTTON_OK = "OK";
    Message.MailGroup.BUTTON_OUTPUT = "出力";
    Message.MailGroup.RESULT_TITLE = "処理を行いました。";
    Message.MailGroup.ERR_UPDATE_DATA = "データ更新に失敗しました。";
    Message.MailGroup.MAIL_ERROR_SEND = "メール送信に失敗しました。";
    Message.MailGroup.NOT_USER = "対象受検者が見つかりません。";
    Message.MailGroup.MAIL_ERROR_UPLOAD = "メール配信時にエラーが発生しました。";
    Message.MailGroup.FILE_CREATE_FAILURE = "ファイル作成時にエラーが発生しました。";

    return {
        Message
    };
};
